import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { TegelModule } from '@scania/tegel-angular-17';
import { DialogService } from 'ng2-bootstrap-modal';
import { NgxMaskService } from 'ngx-mask';
import { ToastrService } from 'ngx-toastr';
import { UtilService } from 'src/app/shared/architecture/services/util.service';
import { Approval } from 'src/app/shared/models/approval.model';
import { UpdateFollowUp } from 'src/app/shared/models/updateFollowUp.model';
import { CreditService } from 'src/app/shared/services/core/credit.service';

@Component({
  selector: 'app-upload-arquivos',
  imports: [TegelModule, CommonModule],
  templateUrl: './upload-arquivos.component.html',
  styleUrl: './upload-arquivos.component.css'
})
export class UploadArquivosComponent implements OnInit {

  constructor(
    private utilService: UtilService,
    private formBuilder: FormBuilder,
    private dialogService: DialogService,
    private toastrService: ToastrService,
    private ngxService: NgxMaskService,
    private creditService: CreditService
  ){}

  selectFile!: File;
  @ViewChild("myInput") childInputVar!: ElementRef;
  arrayBuffer: any;
  excelModel!: any[];
  excelModelHeader!: any[];
  fileOption: any[] = [
    { id: 1, description: "Lista de créditos" },
    { id: 2, description: "Follow Up CA" },
  ];
  pageExcelModel = 1;
  fileOptionId!: string;

  ngOnInit(): void {}

  import(){
    this.childInputVar.nativeElement.click();
  }

  onChangeSelect(event: any){
    this.fileOptionId = event.target.value;
  }

  onFileSelected(event: any){
   // this.selectFile = null;
    if (this.childInputVar.nativeElement.value != ""){
      if (
        event.target.files[0].type == 
         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        event.target.files[0].type == "application/vnd.ms-excel"
      ) {
        this.selectFile = event.target.files[0];
        this.readExcel();
      } else {
        this.toastrService.error("Arquivo Inválido", "Erro");
      }
    }
  }

  readExcel(): void {
    if (this.childInputVar.nativeElement.value != 0) {
      //this.ngxService.start();
      let fileReader = new FileReader();
      fileReader.onload = (e) => {
        this.arrayBuffer = fileReader.result;
        var data = new Uint8Array(this.arrayBuffer);
        var arr = new Array();
        for (var i = 0; i != data.length; ++i)
          arr[i] = String.fromCharCode(data[i]);
        var bstr = arr.join("");
        //var workbook = XLSX.read(bstr, { type: "binary"});
        //var first_sheet_name = workbook.SheetNames[0];
        //var worksheet = workbook.Sheets[first_sheet_name];

        //this.excelModel = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        this.excelModelHeader = this.excelModel[0];
        this.excelModel = this.excelModel.slice(1);
        this.pageExcelModel = 1;
      };
      fileReader.readAsArrayBuffer(this.selectFile);
      //this.ngxService.stop();
    }
  }

  openCriticReport(){
    //this.dialogService.addDialog(OpenCriticComponent, {}, this.utilService.getModalOptions());
  }

  sendData(){
    switch(this.fileOptionId){
      case '1':
        this.approveData();
        break;
      case '2':
        this.updateFollowUp();
        break;
      default:
        this.toastrService.error("Favor informar a opção de Upload", "Erro");
        break;
    }
  }

  approveData(){
    //console.log(this.excelModel);

    let rdnNum = new Date().getSeconds().toString() +
                 new Date().getMinutes().toString() +
                 new Date().getHours().toString() +
                 new Date().getFullYear().toString() +
                 new Date().getMonth().toString() +
                 new Date().getDay().toString();

    for (var i = 0; i != this.excelModel.length; ++i) {

      let approval = new Approval(this.excelModel[i][0]  //pSolicitacao
                                , this.excelModel[i][8] //pBco_cod
                                , this.excelModel[1][10] // pSitCredCod
                                , this.excelModel[i][14] //pObservacoes
                                , rdnNum //pArquivo
                                , this.excelModel[i][12] //pQuantidade
                                , this.excelModel[i][17] //pQuantidadeOriginal
                                , ''
                                , this.excelModel[i][13] //approval S ou N
                                );

      //console.log(approval);

      this.creditService.sendApproval(approval).subscribe((result) => {
        // console.log(approval.id + ' - Tem erro:' + result.hasErrors);
        if (result && !result.hasErrors) {
          this.toastrService.success('Lançamentos realizados', 'Sucesso');
        }
      });
      //this.clear();
    }
  }
  
  updateFollowUp(){
    console.log(this.excelModel);

    let rdnNum = new Date().getSeconds().toString() +
                 new Date().getMinutes().toString() +
                 new Date().getHours().toString() +
                 new Date().getFullYear().toString() +
                 new Date().getMonth().toString() +
                 new Date().getDay().toString();

    for (var i = 0; i != this.excelModel.length; ++i){

      let updateFollowUp = new UpdateFollowUp(this.excelModel[i][0] //pSolicitacao
                                , this.excelModel[i][3] //pTipoFinanc
                                , this.excelModel[i][11] //pSituacao
                                , this.excelModel[i][12] //pQuantidade
                                , this.excelModel[i][14] //pObservacoes
                                , this.excelModel[i][16] //pBco_cod
                                , rdnNum //pArquivo
                                , this.excelModel[i][17] //pQuantidadeOriginal
                                , this.excelModel[i][18] //pSitCredOriginal
                                , 'A'
                                );
      
      //console.log(approval);

      this.creditService.updateFollowUp(updateFollowUp).subscribe((result) => {
        // console.log(approval.id + ' - Tem erro? ' + result.hasErrors);
        if (result && !result.hasErrors) {
          this.toastrService.success('Lançamentos realizados', 'Sucesso');
        }
      });
      //this.clear();
    }
  }

  clear(){
    //this.excelModelHeader = null; //header
    //this.excelModel = null; //body
    //this.selectFile = null;
  }

}
